// extracted by mini-css-extract-plugin
module.exports = {"socialMedia":"_1vfNA","wrapper":"_21uVV","footer":"_2dyxG","footerMobile":"_2EI7i","media":"SSVeD"};